var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
export function VeiculoInfo(_a) {
    var serviceName = _a.serviceName, data = _a.data;
    var formatTotalValue = function (value) {
        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        }).format(value || 0);
    };
    return (_jsx("section", __assign({ className: "w-full max-w-[856px] py-4 sm:py-0.5 bg-light-blue-100 flex justify-start gap-4 sm:justify-between px-6 rounded-lg" }, { children: _jsxs("div", __assign({ className: "flex items-center w-full flex-wrap py-4" }, { children: [_jsxs("div", __assign({ className: cn("w-full sm:w-1/2") }, { children: [_jsx("p", __assign({ className: "font-medium" }, { children: "Placa" })), _jsx("span", __assign({ className: "font-normal" }, { children: data === null || data === void 0 ? void 0 : data.placa }))] })), _jsxs("div", __assign({ className: cn("w-full sm:w-1/2") }, { children: [_jsx("p", __assign({ className: "font-medium" }, { children: "RENAVAM" })), _jsx("span", __assign({ className: "font-normal" }, { children: data === null || data === void 0 ? void 0 : data.renavam }))] }))] })) })));
}
